<template>
  <div class="page-login">
    <header>
      <div class="content">
        <a href="/"><img src="/images/logo.svg" class="header-logo" /></a>
        <a href="/register" class="header-button-si">Sign Up</a>
      </div>
    </header>
    <section class="login">
      <div class="content">
        <div class="login-form">
          <h1>{{trans('auth.account_activation')}}</h1>
          <h4 v-text="message" v-if="status"></h4>
          <h4 v-text="message" style="color:#ff0000;" v-else></h4>
          <br />
          <p>{{trans('auth.back_to_login?')}} <router-link to="/login" class="text-info m-l-5"><b>{{trans('auth.sign_in')}}</b></router-link></p>
        </div>
        <div class="login-hiw">
          <h2>Here’s how it works</h2>
          <ul>
            <li><i>1</i><h3>Complete our first questionnaire</h3><p>Tell us more about your investor preferences and your investment offering</p></li>
            <li><i>2</i><h3>Get some free, suitable investor insights</h3><p>based on the information submitted</p></li>
            <li><i>3</i><h3>Book a video call with one of our experts</h3><p>Our team will review your offering and give you a quote</p></li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token:this.$route.params.token,
      message: i18n.general.processing,
      status: true
    }
  },
  mounted(){

    $("body").addClass("page-login");

    if(!helper.featureAvailable('registration') || !helper.featureAvailable('email_verification')){
      helper.featureNotAvailableMsg();
      return this.$router.push('/');
    }

    axios.get('/api/auth/activate/'+this.token)
        .then(response => response.data)
        .then(response =>  {
          this.message = response.message;
        }).catch(error => {
          // helper.showDataErrorMsg(error);

          this.message = helper.fetchDataErrorMsg(error);
          this.status = false;
    });
  }
}
</script>
